<template>
  <div class="container pb-3">
    <div class="details border rounded">
      <div class="pt-5">
        <div class="text-center">
          <h2>{{ campaign.TITLE }}</h2>
          <img
            :src="getImageSource(campaign.BACKGROUND_PATH)"
            alt="Campaign "
            class="img-fluid rounded campaign-image"
          />
        </div>

        <div class="pt-5 ps-5">
          <p>
            {{ campaign.DETAIL }}
          </p>
        </div>
      </div>
      <div class="text-center py-5">
        <a :href="'/start-donate/' + campaign.ID" class="btn gradient-bg btn-lg">บริจาค <font-awesome-icon :icon="['fas', 'donate']" /></a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useCampaigns } from '../components/scripts/useCampaigns';

const API_BASE_URL = import.meta.env.VITE_API_URL;
const { Campaigns } = useCampaigns();
const route = useRoute();

const campaignID = ref(0);

const campaign = computed(() => {
  return Campaigns.value.find((c) => c.ID == campaignID.value) || {};
});

const getImageSource = (backgroundPath) => {
  if (backgroundPath === '') {
    return `${API_BASE_URL}/images/hero.jpg`;
  } else {
    return API_BASE_URL + backgroundPath;
  }
};

onMounted(() => {
  campaignID.value = route.params.id;
});
</script>

<style scoped>
.campaign-content {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.campaign-image {
  width: 700px;
}
.details {
  background-color: #f5f6fa;
  min-height: 50vh;
}
p {
  text-indent: 40px;
}
</style>
